let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1cBTL")).then(() => parcelRequire('imW3j'));